<template>
  <div
    class="menu-wrapper"
    :style="{'margin-left': (config.menuMarginLeft || 0)+'px'}"
    ref="menuWrapper"
  >
    <!--一级没有子菜单-->
    <el-menu-item
    class="nowrap no-submenu"
      v-for="(item,index) in routes"
      v-if="!item.hidden&& (!item.children || item.children.length == 0)"
      :index="getIndex(item)"
      :key="index"
      @click="clickRouter(item)"
    >
      <!--<em class="iconfont new-iconfont sideBar" :class="item.icon?item.icon:''"></em>-->
      <!-- <el-tooltip class="item" effect="dark" :content="item.menuName" placement="top-start" v-if="getLayout()"> -->
      <span
      :title="item.menuName"
        v-if="item.menuName"
        v-html="highlight(item.menuName,filterKey,parent,item)"
      >{{item.menuName}}</span>
      <!-- </el-tooltip> -->
      <!-- <template v-else>
        <span v-if="item.menuName">{{item.menuName}}</span>
      </template>-->
    </el-menu-item>
    <!--一级有子菜单-->
    <el-submenu
    class="nowrap"
      v-else="!item.hidden&&item.children&&item.children.length > 0"
      :index="getIndex(item)"
      :key="index "
      @click="clickMenuRouter(item)"
      unique-opened="true"
    >
      <!--一级菜单标题-->
      <template slot="title">
        <em class="iconfont sideBar new-iconfont" :class="item.icon?item.icon:''"></em>
        <!-- <el-tooltip class="item" effect="dark" :content="item.menuName" placement="top-start" v-if="getLayout()"> -->
        <span v-if="item.menuName" :title="item.menuName" v-html="highlight(item.menuName,filterKey,parent,item)"></span>
        <!-- </el-tooltip> -->
        <!-- <template v-else>
          <span v-if="item.menuName">{{item.menuName}}</span>
        </template>-->
      </template>
      <sidebar-item
        :is-nest="true"
        :filterKey="filterKey"
        :routes="item.children"
        :key="index"
        :config="config"
        :parent="item"
      ></sidebar-item>
    </el-submenu>
  </div>
</template>

<script>
import { generateTitle } from "@/utils/i18n";

export default {
  name: "SidebarItem",
  props: {
    filterKey: {
      type: String
    },
    parent: {
      default: null
    },
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default() {
        return {
          menuMarginLeft: 0
        };
      }
    }
  },
  watch: {
    filterKey(val) {
      if (val) {
        for (let i = 0; i < this.routes.length; i++) {
          const item = this.routes[i];
          if (this.parent && item.menuName.indexOf(val) >= 0) {
            this.$eventBus.$emit("open-menu-index", this.getIndex(this.parent));
            if (this.$parent.parent) {
              this.$eventBus.$emit(
                "open-menu-index",
                this.getIndex(this.$parent.parent)
              );
            }
            break;
          }
        }
      }
    }
  },
  methods: {
    highlight(value, query, parent, item) {
      // console.log(value)
      if (!query) {
        return value;
      }
      let escapedKeyword = query;
      if (query) {
        escapedKeyword = query.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
      } else {
        return value;
      }
      const iQuery = new RegExp(escapedKeyword, "gi");
      const res = value.replace(
        iQuery,
        `<span style="color:yellow;">${query}</span>`
      );
      // if (parent && res.indexOf('<span') >= 0) {
      //   this.$eventBus.$emit('open-menu-index', this.getIndex(parent))
      // }
      return res;
    },
    generateTitle,
    getIcon(item) {
      let iconItem = null;
      if (!item.icon) {
        if (item.level === 1) {
          iconItem = "documentation";
        } else if (item.level === 2) {
          iconItem = "clipboard";
        } else if (item.level === 3) {
          iconItem = "table";
        } else {
          iconItem = "excel";
        }
      } else {
        iconItem = item.icon;
      }
      return iconItem;
    },
    getLayout() {
      return true;
    },
    getIndex(item) {
      if (!item) {
        console.error(item);
        return "";
      }

      if (item.path) {
        return item.path;
      } else if (item.configKey) {
        return "/config/" + encodeURIComponent(item.configKey);
      } else {
        return '' + item.id;
      }
    },
    clickRouter(item) {
      if (item.tab) {
        item.path = "/tab/" + encodeURIComponent(item.tab);
      }
      if (item.configKey) {
        item.path = "/config/" + encodeURIComponent(item.configKey);
      }
      if (item.query && item.query.params) {
        const a = JSON.stringify(item.query.params);
        item.query.params = a;
      }
      if (item.path && ~item.path.indexOf("iframe")) {
        this.$store.dispatch("addIframeData", item);
      }
      this.$router.push(item);
    },
    encodeSearchKey(key) {
      const encodeArr = [
        {
          code: "%",
          encode: "%25"
        },
        {
          code: "?",
          encode: "%3F"
        },
        {
          code: "#",
          encode: "%23"
        },
        {
          code: "&",
          encode: "%26"
        },
        {
          code: "=",
          encode: "%3D"
        }
      ];
      return key.replace(/[%?#&=]/g, ($, index, str) => {
        for (const k of encodeArr) {
          if (k.code === $) {
            return k.encode;
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.nowrap {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.no-submenu {
    padding: 0 10px;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue